import { STORYBLOK_SLICES } from '~/lib/storyblok-types'

import BigTitle from '~/components/Slices/BigTitle'
import EditorialTitleParagraphCta from '~/components/Slices/EditorialTitleParagraphCta'
import HeroHalf from '~/components/Slices/HeroHalf'
import HeroSlider from '~/components/Slices/HeroSlider'
import PanelContact from '~/components/Slices/PanelContact'
import ProductsPinsPush from '~/components/Slices/ProductsPinsPush'
import PushGeneric from '~/components/Slices/PushGeneric'
import PushTypeListing from '~/components/Slices/PushTypeListing'
import ThreeColumnsImageWysiwyg from '~/components/Slices/ThreeColumnsImageWysiwyg'
import TwoColumnsImageTitleWysiwygs from '~/components/Slices/TwoColumnsImageTitleWysiwygs'
import TwoColumnsLayoutLine from '~/components/Slices/TwoColumnsLayoutLine'

export default {
  [STORYBLOK_SLICES.HERO_SLIDER]: HeroSlider,
  [STORYBLOK_SLICES.HERO_HALF]: HeroHalf,
  [STORYBLOK_SLICES.TWO_COLUMNS_LAYOUT_LINE]: TwoColumnsLayoutLine,
  [STORYBLOK_SLICES.HEADER_TWO_COLUMNS_LAYOUT]: TwoColumnsLayoutLine,
  [STORYBLOK_SLICES.PRODUCTS_PINS_PUSH]: ProductsPinsPush,
  [STORYBLOK_SLICES.PUSH_DESIGNERS]: PushTypeListing,
  [STORYBLOK_SLICES.PUSH_GENERIC]: PushGeneric,
  [STORYBLOK_SLICES.BIG_TITLE]: BigTitle,
  [STORYBLOK_SLICES.EDITORIAL_TITLE_PARAGRAPH_CTA]: EditorialTitleParagraphCta,
  [STORYBLOK_SLICES.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS]:
    TwoColumnsImageTitleWysiwygs,
  [STORYBLOK_SLICES.THREE_COLUMNS_IMAGE_WYSIWYG]: ThreeColumnsImageWysiwyg,
  [STORYBLOK_SLICES.PANEL_CONTACT]: PanelContact,
}
